import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from "@mui/material";
export var SeasonStatusChip = function (_a) {
    var season = _a.season, _b = _a.size, size = _b === void 0 ? "small" : _b;
    var getStatusConfig = function (status) {
        var statusConfig = {
            draft: { color: "warning", label: "Draft" },
            active: { color: "success", label: "Active" },
            completed: { color: "info", label: "Completed" },
            cancelled: { color: "error", label: "Cancelled" },
        };
        return (statusConfig[status] || statusConfig.draft);
    };
    if (!season.status) {
        return null;
    }
    var config = getStatusConfig(season.status);
    return _jsx(Chip, { color: config.color, label: config.label, size: size });
};
